/**
 * Lightweight scroll-reveal. Elements with .ir-reveal fade/rise in as they enter
 * the viewport. Progressive + CWV-safe:
 *  - adds html.ir-js so the hidden start state only applies when JS is running
 *    (no JS / failure → content stays visible).
 *  - prefers-reduced-motion → no hiding, no animation.
 *  - IntersectionObserver; falls back to showing everything if unsupported.
 */
(function () {
  if (window.__irRevealInit) return;
  window.__irRevealInit = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('ir-js');

  function run(ctx) {
    var els = (ctx || document).querySelectorAll('.ir-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', function () { run(); });
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
